import React, { useState } from "react";
import { Link } from "../../components/LinkIcon";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { tryNow } from "../../utils";

export const SSOPageContentSence = () => {
  const [selectIndex, setSelectIndex] = useState(0);
  const { t } = useTranslation();
  const address = "learn.ssoPage.";
  const select_list = Array.apply(null, Array(3)).map((item, index) => {
    return {
      label: t(address + `box_three.${index}.label`),
      subLabel: t(address + `box_three.${index}.subLabel`),
      content: t(address + `box_three.${index}.content`),
      imgUrl: t(address + `box_three.${index}.imgUrl`),
    };
  });
  const renderSSOPageContentSencePC = () => {
    return (
      <section className="ssoPage_children_sence_pc">
        <div className="children_four_left">
          {select_list.map((item, index) => (
            <img
              style={
                selectIndex === index
                  ? { display: "block" }
                  : { display: "none" }
              }
              src={item?.imgUrl}
              alt="authing"
            />
          ))}
        </div>
        <div className="children_four_right">
          <div className="title">{t(address + "box_three.title")}</div>
          <div className="item_container">
            {select_list?.map((item, index) => (
              <div
                onClick={() => setSelectIndex(index)}
                key={index}
                style={
                  selectIndex === index
                    ? { background: "#396AFF", color: "#fff" }
                    : {}
                }
                className="item_title"
              >
                {item?.label}
              </div>
            ))}
          </div>
          {select_list?.map((item, index) => (
            <div
              style={
                selectIndex === index
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <div className="subtitle">{item?.subLabel}</div>
              <div className="content">{item?.content}</div>
            </div>
          ))}
          <div className="use-free-btn" onClick={tryNow}>
            <Link>{t(address + `box_three.link`)}</Link>
          </div>
        </div>
      </section>
    );
  };
  const renderSSOPageContentSenceMobile = () => {
    return (
      <section className="ssoPage_children_sence_mobile">
        <div className="headline">{t(address + "box_three.title")}</div>
        {select_list.map((item) => (
          <div className="content-block">
            <div className="title">{item.subLabel}</div>
            <div className="content">{item.content}</div>
            <div className="img-warp">
              <img src={item.imgUrl} alt="authing" />
            </div>
          </div>
        ))}
      </section>
    );
  };
  return (
    <>
      {renderSSOPageContentSencePC()}
      {renderSSOPageContentSenceMobile()}
    </>
  );
};
